// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"info-panel_wrapper__PY0Au"};